import React from 'react';
import PropTypes from 'prop-types';
import Appareil from '../assets/appareil.jpg'
import ButtonSendCode from '../assets/Button.png'
import InfoCodeLogo from '../assets/ph_info.png'
import '../styles/Main.scss';
import 'animate.css';
import FlashMessageComponent from '../components/FlashMessageComponent';
import { useState } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { wait } from '@testing-library/user-event/dist/utils';


Main.propTypes = {
    
};

function checkMobile()
{
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function Main(props) {
    const navigate = useNavigate();

    const [isFlash, setIsFlash] = useState({
        "display": false,
        "message": ""
    });

    const [isWriting, setIsWriting] = useState(false);

    var handleKeyUp = (e) => {
        console.log("handle key up", e);
        var target = e.target;
        if (e.code == null && e.key == null)
            return
        var code = (e.code) ? e.code : e.key;
        if (e.code.includes("Backspace") || e.key.includes("Backspace")) {
            if (target.getAttribute("val")) {
                target.removeAttribute("val");
                return;
            }
            target = target.previousElementSibling;
            if (target) {
                document.getElementsByClassName("container-input")[0].setAttribute("data", "Backspace");
                target.focus();
            }
            return;
        }
    }

    var handleInput = (e) => {
        var target = e.target;
        var myLength = target.value.length;
        target.value = target.value.toUpperCase();
        if (myLength >= 1) {
            if (myLength > 1) {
                target.value = target.value[1];
                target.value = target.value.toUpperCase();
            }
            target.setAttribute("val", target.value);
            var next = target;
            next = next.nextElementSibling
            if (next) {
                document.getElementsByClassName("container-input")[0].setAttribute("data", "Writing");
                next.focus();
            }
        }
    }


    var sendCode = async (e) => {
        var codes = document.getElementsByClassName('underline');
        var raw = "";
        for (let code of codes) {
            raw += code.value;
        }

        try {
            var response = await axios.get("https://pellicule.triportrait.com/api/photos/" + raw);
            navigate(`/photos/${raw}`);
            window.scrollTo(0, 0);
        } catch (e) {
            var message = `Erreur ! Le code ${raw} n’est associé à aucun tirage.`;
            setIsFlash({message, "display":true});
        }

    };

    var _onFocus = (e) => {
        if (document.getElementsByClassName("container-input")[0].getAttribute("data") == "Backspace") {
            document.getElementsByClassName("container-input")[0].removeAttribute("data");
            return;
        }
        var target = e.target;
        if (document.getElementsByClassName("container-input")[0].getAttribute("data") == "Writing") {
            document.getElementsByClassName("container-input")[0].removeAttribute("data");
            return;
        }
        if (target.value == "") {
            while (target && target.value === "" && target.previousElementSibling)
                target = target.previousElementSibling;
            if (!target.previousElementSibling && target.value === "")
                target.focus();
            else if (target.nextElementSibling)
                target.nextElementSibling.focus();
        }
    };


    return (
        <div className="main-container">
            <FlashMessageComponent message={isFlash.message} colorBackground="rgb(255,235,234)" color="rgb(254, 91, 91)" display={isFlash.display} setIsFlash={setIsFlash}/>
            <div className="hero-image">
                <img src={"https://pellicule.triportrait.com/home.jpg"}/>
            </div>
            <div className='left-main-part'>
                <div className='content-left-part'>
                <p className="explain" align="left">Renseignez votre code pour récupérer vos photos :</p>
                <div className="main-input">
                    <div className='content-main-input'>
                        <div className="container-input" onInput={handleInput} onKeyUp={handleKeyUp} onFocus={_onFocus}>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                            <input className='underline' type="number" maxLength='2' min="1" max="9"/>
                        </div>
                        <div className="main-image-container" onClick={sendCode}>
                            <img src={ButtonSendCode} />
                        </div>
                    </div>
                    <div className="container-info-code">
                        <div className='info-code'>
                            <img src={InfoCodeLogo} />
                        </div>
                        <p>Vous avez 30 jours pour télécharger vos photos.</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default Main;